import React from "react";

const GameCard = ({ game, onClick }) => {
  const imgSrc =
    game.image ||
    (game.img && `${game.img}`) ||
    (game.logo && `https://space.mil-168.com/${game.logo}`) ||
    (game.image && `https://space.mil-168.com/${game.image}`) ||
    "";
  const title = game.gameName || game.name || game.title || "Game";

  return (
    <div
      style={{
        backgroundColor: "#2d2d2d",
        borderRadius: 12,
        textAlign: "center",
        cursor: "pointer",
        transition: "all 0.3s ease",
        border: "1px solid #404040",
        position: "relative",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow =
          "0 8px 25px var(--primaryColor,--primaryColor)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
      onClick={onClick}
    >
      <img
        src={imgSrc}
        alt={title}
        style={{ width: "100%", objectFit: "contain", borderRadius: 8 }}
        onError={(e) => (e.currentTarget.style.display = "none")}
      />
      <h3
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          color: "white",
          fontSize: 14,
          margin: 0,
          padding: "4px 12px",
          fontWeight: 600,
          backgroundColor: "rgba(0,0,0,0.7)",
          borderRadius: "0 0 8px 8px",
        }}
      >
        {title}
      </h3>
    </div>
  );
};

export default GameCard;
